<div>
  <h2 [innerHTML] = "innerHeading"></h2>
  <p [innerHTML] = "innerText"></p>  
</div>
